"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const React = require("react");
const src_1 = require("@rover/ts-bootstrap/dist/src");
const TapBehaviorLabel = ({ tapBehavior }) => {
    let { type, url } = tapBehavior;
    if (url !== null && url.includes('https')) {
        type = 'PRESENT_WEBSITE';
    }
    switch (type) {
        case 'PRESENT_EXPERIENCE':
            return React.createElement(src_1.Text, { text: "Present an Experience", size: "small" });
        case 'PRESENT_WEBSITE':
            return (React.createElement("div", { style: {
                    display: 'flex',
                } },
                React.createElement(src_1.Text, { textStyle: { marginRight: 8 }, text: "Present a website", size: "small" }),
                React.createElement(src_1.ExternalLinkIcon, { fill: src_1.turquoise, onClick: (e) => {
                        e.stopPropagation();
                        window.open(url, 'tab');
                    } })));
        case 'OPEN_URL':
            return (React.createElement("div", { style: {
                    display: 'flex',
                } },
                React.createElement(src_1.Text, { textStyle: { marginRight: 8 }, text: "Open a deep link", size: "small" }),
                React.createElement(src_1.Text, { text: url, size: "small" })));
        case 'DEFAULT':
            return React.createElement(src_1.Text, { text: "Open the app", size: "small" });
        default:
            return;
    }
};
exports.default = TapBehaviorLabel;
